import { storybookReady } from '../../../core/js/utils'

let storybook

(async function () {
  storybook = await storybookReady()

  document.querySelectorAll('.Nav__Wrapper').forEach(item => {
    let navigation = new Navigation(item)
  })
})()

class Navigation {
  // class methods
  constructor (element) {
    storybook && console.log('Navigation', element)

    this.navItemsAndLogin = element.querySelectorAll('.Navigation > .Button,.Login__Container')
    this.navItems = element.querySelectorAll('.Navigation > .Button')

    this.privateNavItems = element.querySelectorAll('.Navigation > .Button[data-login]')

    this.navContents = document.querySelectorAll('[data-nav-content]')

    this.nav = element.querySelector('.Navigation')

    this.header = document.querySelector('.Header')

    this.navHeader = element.querySelector('.Navigation > .Nav__Header')

    this.headerHeight = this.header.getBoundingClientRect().height

    this.navYPosition = this.header && this.nav && Math.round(this.headerHeight + this.nav.getBoundingClientRect().height)

    this.isSmall = document.querySelector('html').getBoundingClientRect().width <= 768

    this.updatenavPosition()

    this.scrollListener()

    this.initEventListeners()
  }

  updateProperties () {
    storybook && console.log('updateProperties')

    /* update variables */
    storybook && console.log('update variable')

    this.headerHeight = this.header.getBoundingClientRect().height

    this.navYPosition = this.header && this.nav && Math.round(this.headerHeight + this.nav.getBoundingClientRect().height)

    this.isSmall = document.querySelector('html').getBoundingClientRect().width <= 768

    this.updatenavPosition()
  }

  updatenavPosition () {
    if (this.headerHeight) {
      document.querySelectorAll('.Nav__Wrapper').forEach(item => {
        item.style.top = this.headerHeight + 'px'
      })
    }
  }
  initLoginListener () {
    storybook && console.log('initLoginListener')

    const updateDestinationValue = (anchor) => {
      if (anchor.hasAttribute('href')) {
        let loginForm = document.querySelector('.Login form')
        let destination = loginForm && loginForm['destination']
        if (destination) {
          destination.value = destination.value.replace(/(%23.*?)?$/, encodeURIComponent(anchor.getAttribute('href')))
        }
      }
    }

    this.navItemsAndLogin.forEach((navItem) => {
      navItem && navItem.addEventListener('mouseover', (event) => {
        storybook && console.log('mouseover')
        if (typeof this.nav.dataset.showLogin !== 'undefined') {
          return
        }
        if (event.currentTarget.hasAttribute('data-login') || event.currentTarget.classList.contains('Login__Container')) {
          this.nav.dataset.showLogin = ''
          updateDestinationValue(event.currentTarget)
        }
      })

      navItem && navItem.addEventListener('mouseenter', (event) => {
        if (typeof this.nav.dataset.showLogin !== 'undefined') {
          return
        }
        if (event.currentTarget.hasAttribute('data-login') || event.currentTarget.classList.contains('Login__Container')) {
          this.nav.dataset.showLogin = ''
          updateDestinationValue(event.currentTarget)
        }
      })

      navItem && navItem.addEventListener('mouseleave', (event) => {
        delete this.nav.dataset.showLogin
      })
    })

    this.privateNavItems.forEach((privateNavItem) => {

      let ctx = this
      privateNavItem && privateNavItem.addEventListener('click', (event) => {

        if (this.isSmall) {
          let loginContent = document.querySelector('.Login')
          if (loginContent) {
            const modal = new tingle.modal({
              closeLabel: '',
              cssClass: ['Login__Modal'],
              onOpen: function () {
                ctx.nav.dataset.status = 'close'
              }
            })
            modal.setContent(loginContent)
            modal.open()
          }
        }
      })
    })
  }

  scrollListener () {
    storybook && console.log('scrollListener')
    let currentContentItem
    if (this.navContents.length) {
      for (let i = 0; i < this.navContents.length; ++i) {
        if (window.pageYOffset + this.navYPosition > this.navContents[i].offsetTop - 50 && window.pageYOffset + this.navYPosition + 50 < this.navContents[i].offsetTop + this.navContents[i].offsetHeight) {
          currentContentItem = this.navContents[i]
        }
      }
    }

    if (currentContentItem) {
      this.navItems.forEach((navItem) => {
        navItem.setAttribute('aria-current', false)
        navItem.blur()
      })
      const currentNavItem = document.querySelector(`.Navigation .Button[href='#${currentContentItem.id}']`)

      if (currentNavItem) {
        storybook && console.log('current nav item: ' + currentNavItem.id)
      }

      currentNavItem && currentNavItem.setAttribute('aria-current', true)
    }

    if (!currentContentItem) {
      this.navItems.forEach((navItem) => {
        navItem.setAttribute('aria-current', false)
        navItem.blur()
      })
    }
  }

  initEventListeners () {
    storybook && console.log('initEventListeners')
    this.initLoginListener()

    this.navHeader && this.navHeader.addEventListener('click', (event) => {
      event.preventDefault()
      this.nav.dataset.status = (this.nav.dataset.status === 'close' ? 'open' : 'close')
    })

    this.navItems.forEach((navItem) => {
      navItem.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()

        if (!event.currentTarget.hasAttribute('data-login')) {
          const target = event.currentTarget

          storybook && console.log(target)

          const contentSelector = target.getAttribute('href')

          const content = document.querySelector(contentSelector)

          storybook && console.log('contentSelector: ' + contentSelector)

          window.scrollTo(0, content.offsetTop - this.navYPosition)
        }
      })
    })

    window.addEventListener('scroll', (event) => {
      this.scrollListener()
    })

    window.addEventListener('resize', (event) => {
      this.updateProperties()
    })
  }
}
